export default __webpack_public_path__ + "static/challenge-9cc27184c12f59c35bc717d6ba7185e1.jpg";